import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { Fragment } from 'react';
import AppLink from '@/components/elementary/AppLink';
interface SeoNavigationFallbackProps {
  items?: Data.Component<'layout-utilities.navbar-item'>[] | null;
  login?: Data.Component<'utilities.link'> | null;
  buttons?: Data.Component<'utilities.link'>[] | null;
  dropdown?: Data.Component<'layout-utilities.dropdown-item'> | null;
}
export function SeoNavigationFallback(t0) {
  const $ = _c(13);
  const {
    items,
    login,
    buttons,
    dropdown
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = Array.isArray(items) && items.map(_temp4);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== login) {
    t2 = login?.href && login?.label ? <li><AppLink href={login.href} tabIndex={-1}>{login.label}</AppLink></li> : null;
    $[2] = login;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== buttons) {
    t3 = buttons?.map(_temp5);
    $[4] = buttons;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dropdown?.links) {
    t4 = dropdown?.links?.map(_temp6);
    $[6] = dropdown?.links;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <nav className="sr-only" aria-label="Main navigation"><ul>{t1}{t2}{t3}{t4}</ul></nav>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp6(link_0) {
  return link_0.href ? <li key={link_0.id}><AppLink href={link_0.href} openExternalInNewTab={link_0.newTab ?? false} tabIndex={-1}>{link_0.title}</AppLink></li> : null;
}
function _temp5(primaryButton) {
  return primaryButton.href ? <li key={primaryButton.id}><AppLink href={primaryButton.href} tabIndex={-1}>{primaryButton.label}</AppLink></li> : null;
}
function _temp4(item) {
  return <li key={item.id}>{item.href ? <AppLink href={item.href} openExternalInNewTab={item.newTab ?? false} tabIndex={-1}>{item.label}</AppLink> : <span>{item.label}</span>}{item.columns?.length ? <ul>{item.columns.map(_temp3)}</ul> : null}</li>;
}
function _temp3(column) {
  return <Fragment key={column.id}>{column.groups?.map(_temp2)}</Fragment>;
}
function _temp2(group) {
  return <li key={group.id}>{group.links?.map(_temp)}{group.moreLink?.href && <AppLink href={group.moreLink.href} openExternalInNewTab={group.moreLink.newTab ?? false} tabIndex={-1}>{group.moreLink.title}</AppLink>}</li>;
}
function _temp(link) {
  return link.href ? <AppLink key={link.id} href={link.href} openExternalInNewTab={link.newTab ?? false} tabIndex={-1}>{link.title}</AppLink> : null;
}